<template>
  <div>
      <base-button block type="default" class="btn btn-neutral btn-icon" @click="modal = true">
        <span class="btn-inner--icon">
        <i class="fa fa-globe mr-2"></i>
        </span>
        <span class="nav-link-inner--text">{{ $root.$i18n.locale }}</span>
      </base-button>
      <modal :show.sync="modal"
              body-classes="p-0"
              modal-classes="modal-dialog-centered modal-sm">
              <h6 slot="header" class="modal-title" id="modal-title-default">{{ $t('nav.selectLanguage') }}</h6>
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
              <template>
                  <div class="btn-wrapper">
                    <language-radio name="nl" class="mb-3" v-model="$root.$i18n.locale">
                      Nederlands
                    </language-radio>
                    <language-radio name="en" class="mb-3" v-model="$root.$i18n.locale">
                      English
                    </language-radio>
                  </div>
              </template>
          </card>
      </modal>
  </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import LanguageRadio from "@/components/LanguageRadio.vue";

export default {
  components: {
    Modal,
    LanguageRadio
  },
  data() {
    return {
      modal: false
    };
  }
};
</script>
